var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.771 0L15.6962 2.92516L13.4662 5.15608L10.5411 2.23092L12.771 0ZM2.05713 13.639H4.98228L12.0875 6.53383L9.16233 3.60867L2.05713 10.7139V13.639Z",
    fill: "#1B242C",
    fillOpacity: 0.74
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 16.8954 0.895431 16 2 16H14C15.1046 16 16 16.8954 16 18H0Z",
    fill: "#535960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.93e1932745f2dfa83c173fbbc460fa18.svg";
export { ForwardRef as ReactComponent };